import React from 'react';
import { motion } from 'framer-motion';
import {
  Shirt, PersonStanding, Video, Maximize, Wand2, Megaphone, Sparkles,
  ShieldCheck, Workflow, Users, Plug, Layers, Lock,
} from 'lucide-react';
import { useContent } from '../../lib/content';
import { pickLocale } from '../../lib/api';

const ICONS = {
  Shirt, PersonStanding, Video, Maximize, Wand2, Megaphone, Sparkles,
  ShieldCheck, Workflow, Users, Plug, Layers, Lock,
};

// Smaller secondary section: AI generation capabilities (the commoditized layer)
export default function CapabilitiesStrip() {
  const { content, locale } = useContent();
  const data = content.capabilities || {};
  const items = data.items || [];

  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="section bg-bg-secondary border-y border-line"
    >
      <div className="container-x">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <p className="text-eyebrow mb-4">{pickLocale(data.eyebrow, locale)}</p>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight text-ink leading-[1.05] mb-4" data-testid="capabilities-title">
            {pickLocale(data.title, locale)}
          </h2>
          <p className="text-ink-muted text-base md:text-lg max-w-xl leading-relaxed">
            {pickLocale(data.subtitle, locale)}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-line border border-line rounded-md overflow-hidden">
          {items.map((item, i) => {
            const Ic = ICONS[item.icon] || Sparkles;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                className="bg-bg p-5 md:p-7 flex flex-col gap-4 group"
                data-testid={`capability-${i}`}
              >
                <div className="w-10 h-10 rounded-md border border-line-strong flex items-center justify-center text-acid group-hover:border-acid transition-colors">
                  <Ic size={16} strokeWidth={1.4} />
                </div>
                <h3 className="font-mono text-[13px] uppercase tracking-[0.06em] text-ink leading-tight">
                  {pickLocale(item.title, locale)}
                </h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
